import $axios from '@/axios-instance'

export default class IntegrationService {
    baseUrl = '/api/v1/admin/registries'
    // baseUrlGateway = '/api/v1/auth'

    static make() {
        return new IntegrationService()
    }

    index(registry, params) {
        return $axios.get(`${this.baseUrl}/${registry}/integrations`, params)
    }

    store(registry, params) {
        return $axios.post(`${this.baseUrl}/${registry}/integrations`, params)
    }

    show(registry, id, params) {
        return $axios.get(`${this.baseUrl}/${registry}/integrations/${id}`, params)
    }

    update(registry, id, params) {
        return $axios.post(`${this.baseUrl}/${registry}/integrations/${id}`, {
            ...params,
            _method: 'PUT',
        })
    }

    destroy(registry, id, params) {
        return $axios.post(`${this.baseUrl}/${registry}/integrations/${id}`, {
          ...params,
          _method: 'DELETE',
        })
    }
}

export const IntegrationServiceInstance = new IntegrationService()